import React, { useEffect, useState } from 'react';
import { Button, Space, Typography } from 'antd';
import { DownloadOutlined, CloseOutlined } from '@ant-design/icons';
import './PwaInstallPrompt.css';

const DISMISS_KEY = 'pwa:install:dismissed';
const DISMISS_DAYS = 7;

const PwaInstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
        const daysAgo = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
        if (dismissedAt && daysAgo < DISMISS_DAYS) return;

        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setVisible(true);
        };

        const installedHandler = () => {
            setVisible(false);
            setDeferredPrompt(null);
        };

        window.addEventListener('beforeinstallprompt', handler);
        window.addEventListener('appinstalled', installedHandler);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
            window.removeEventListener('appinstalled', installedHandler);
        };
    }, []);

    const handleInstall = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            setVisible(false);
        }
        setDeferredPrompt(null);
    };

    const handleDismiss = () => {
        localStorage.setItem(DISMISS_KEY, String(Date.now()));
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="pwa-install-prompt">
            <div className="pwa-install-prompt-content">
                <div className="pwa-install-prompt-icon">
                    <DownloadOutlined />
                </div>
                <div className="pwa-install-prompt-text">
                    <Typography.Text strong style={{ display: 'block', fontSize: 14 }}>
                        Install AgriInventory
                    </Typography.Text>
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                        Add to home screen for offline access and faster startup.
                    </Typography.Text>
                </div>
                <Space>
                    <Button type="primary" size="small" onClick={handleInstall} style={{ borderRadius: 6, fontWeight: 600 }}>
                        Install
                    </Button>
                    <Button
                        type="text"
                        size="small"
                        icon={<CloseOutlined />}
                        onClick={handleDismiss}
                        aria-label="Dismiss install prompt"
                    />
                </Space>
            </div>
        </div>
    );
};

export default PwaInstallPrompt;
